import { useEffect, useState } from 'react';
import { Sun } from '../themes/theme'

export default function BackgroundSun() {

  return (
    <div>
      <Sun />
    </div>
  );
}